/** رنگ‌های برند پنل */
export const BRAND_PRIMARY = '#0D887E';
export const BRAND_PRIMARY_HOVER = '#0a6f67';
export const BRAND_DARK_BG = '#070B14';

/** کلاس دکمهٔ اصلی هماهنگ با برند */
export const PANEL_PRIMARY_BTN_CLASS =
  'bg-brand-primary hover:bg-brand-primary-hover border-brand-primary border-0 text-white';

/** استایل دکمه تأیید حذف در Modal.confirm (قابل‌مشاهده بدون hover) */
export const PANEL_DANGER_OK_BUTTON_PROPS = {
  danger: true,
  style: {
    backgroundColor: '#ff4d4f',
    borderColor: '#ff4d4f',
    color: '#fff',
  },
};

/** کادر عملیات گروهی — یکسان در کل پروژه */
export const BULK_ACTION_BAR_CLASS =
  'mb-4 flex items-center gap-3 p-3 bg-orange-50 dark:bg-orange-900/10 border border-orange-200 dark:border-orange-800 rounded-lg';

export const BULK_ACTION_BAR_TEXT_CLASS =
  'text-sm text-orange-700 dark:text-orange-300';
